import { Box, Checkbox, Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { BaseLegend } from '@resistapp/client/components/plots/legends/base-legend';
import { ChipGeneLegend } from '@resistapp/client/components/plots/legends/chip-gene-legend';
import { ChipSampleLegend } from '@resistapp/client/components/plots/legends/chip-sample-legend';
import { CtLegend } from '@resistapp/client/components/plots/legends/ct-legend';
import { EfficiencyLegend } from '@resistapp/client/components/plots/legends/efficiency-legend';
import { SmartChipFlag } from '@resistapp/common/types';
import { useChipContext } from './use-chip-context';

export function ChipViewLegends() {
  const {
    uniqueGroups,
    assayColorByAssay,
    selectedGroups,
    toggleGroupStable,
    sampleLegendItems,
    selectedSamples,
    toggleSampleStable,
    selectedMetric,
    setSelectedMetricStable,
    highlightFlag,
    setHighlightFlagStable,
    flagOptions,
    showRejected,
    setShowRejectedStable,
  } = useChipContext();

  const legendHeight = '450px';

  return (
    <LegendContainer>
      <Box mb={3}>
        <BaseLegend
          key={`flag-legend-${highlightFlag}`}
          header="Options"
          description=""
          options={flagOptions}
          onChange={(value: string | undefined) => {
            setHighlightFlagStable(value ? (value as SmartChipFlag) : 'None');
          }}
          defaultValue={highlightFlag}
          optionMinimum={0}
        >
          <Flex alignItems="center" gap={2} ml={2} mt={2}>
            <Checkbox
              size="sm"
              isChecked={selectedMetric === 'efficiency'}
              onChange={() => {
                setSelectedMetricStable(prev => (prev === 'ct' ? 'efficiency' : 'ct'));
              }}
            >
              Show Efficiencies
            </Checkbox>
          </Flex>
          <Flex alignItems="center" gap={2} ml={2} mt={2}>
            <Checkbox
              size="sm"
              isChecked={showRejected}
              onChange={() => {
                setShowRejectedStable(prev => !prev);
              }}
            >
              Mark Disqualified
            </Checkbox>
          </Flex>
        </BaseLegend>
        <Box height="16px" />
      </Box>
      {selectedMetric === 'ct' ? (
        <>
          <CtLegend legendHeight="180px" />
          <Box height="16px" />
        </>
      ) : (
        <>
          <EfficiencyLegend legendHeight="180px" />
          <Box height="16px" />
        </>
      )}
      <Box height="16px" />
      <ChipGeneLegend
        genes={uniqueGroups}
        colors={assayColorByAssay}
        selected={selectedGroups}
        onToggle={toggleGroupStable}
        legendHeight={legendHeight}
        header="Assays"
        description="Toggle assays"
      />
      <Box height="36px" />
      <ChipSampleLegend
        items={sampleLegendItems}
        selected={selectedSamples}
        onToggle={toggleSampleStable}
        legendHeight={legendHeight}
        description="Toggle tech reps"
      />
    </LegendContainer>
  );
}

const LegendContainer = styled(Box)`
  min-width: 210px;
  max-width: 210px;
`;
